import React, { useRef, useState } from "react";
import {
  Button,
  Select,
  Form,
  Input,
  DatePicker,
  Modal,
  InputNumber,
  Switch,
  Row,
  Col,
} from "antd";
import {
  CloseOutlined,
  FormOutlined,
  // PlusOutlined,
  // DeleteTwoTone,
  LoadingOutlined,
  SyncOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import { env } from "../../../config";
import Axios from "../../../api/Axios";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
const { Option } = Select;
const { RangePicker } = DatePicker;
const AddSub = ({
  addModalReturn,
  enrollments,
  billings,
  category,
  subscription,
  handleCancel,
  visible,
  applications,
  categoryType,
  namingData,
  iltEnable,
}) => {
  const formRef = useRef();
  // console.log(categoryType);
  // const handleReset = () => {
  //   formRef.current.resetFields();
  // };
  const { id } = useParams();
  const [allocated_views_switch, setAllocated_views_switch] = useState(true);
  const [ilt, setIlt] = useState(iltEnable === true ? true : false);
  const [AiEnabled, setAiEnabled] = useState(false);
  const [isUserExists, setIsUserExists] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disableOnComp, setDisableOnComp] = useState(false);
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }

  // const compBldrProducts =
  //   applications.find((app) => app.name === "CompBldr")?.products || [];

  const csrfToken = getCookie("csrftoken");
  const onFinish = async (values, event) => {
    setLoading(true);
    const { dateRange, products, ai_enabled, ...otherValues } = values;
    const filteredValues = Object.fromEntries(
      Object.entries(otherValues).filter(
        ([_, value]) => value !== undefined && value !== null
      )
    );

    const startDate = dayjs(dateRange[0]);
    const endDate = dayjs(dateRange[1]);
    console.log(dateRange[0]);

    const payload = {
      ...filteredValues,
      start_date: startDate.format("YYYY-MM-DD"),
      end_date: endDate.format("YYYY-MM-DD"),
      organization: parseInt(id, 10),
      ...(moduleType === "RC" && { ai_enabled: values.ai_enabled }),
    };

    // let productsPayload = [];
    // if (products && products.length > 0) {
    //   productsPayload = products.map((product) => {
    //     const { dateRange, ...otherProductValues } = product;
    //     const filteredProductValues = Object.fromEntries(
    //       Object.entries(otherProductValues).filter(
    //         ([_, value]) => value !== undefined && value !== null
    //       )
    //     );

    //     const productStartDate = dayjs(dateRange[0]);
    //     const productEndDate = dayjs(dateRange[1]);

    //     return {
    //       ...filteredProductValues,
    //       start_date: productStartDate.format("YYYY-MM-DD"),
    //       end_date: productEndDate.format("YYYY-MM-DD"),
    //     };
    //   });
    //   payload.products = productsPayload;
    // }

    console.log(payload, "finalPayload");

    try {
      const res = await Axios.post("/orgsubscriptioncreate/", payload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      console.log(res);
      handleReset();
      setLoading(false);
      addModalReturn(true);
    } catch (err) {
      console.log(err);
      handleReset();
      setLoading(false);
      addModalReturn(false);
    }
  };

  // const addRow = () => {
  //   const values = form.getFieldValue("products") || [];
  //   form.setFieldsValue({ products: [...values, {}] });
  // };

  // const removeRow = (index) => {
  //   const values = form.getFieldValue("products");
  //   const removedRowValues = values[index];
  //   console.log(removedRowValues?.id?.value, "istheremovedProduct");

  //   values.splice(index, 1);
  //   form.setFieldsValue({ products: values });
  // };
  // const isProductUnique = (value) => {
  //   return new Promise((resolve, reject) => {
  //     console.log(value, form.getFieldValue("products"), "isProductUnique");

  //     const selectedProducts = form
  //       .getFieldValue("products")
  //       .map((product) => product.id);

  //     const isUnique =
  //       selectedProducts.indexOf(value) === selectedProducts.lastIndexOf(value);

  //     console.log("Is unique?", isUnique);

  //     if (isUnique) {
  //       resolve();
  //     } else {
  //       reject("Product must be unique"); // Reject the promise with an error message
  //     }
  //   });
  // };

  // useEffect(() => {
  //   const allApps = [];

  //   const removeApps = (appName) => {
  //     const indextoRemove = applications.findIndex(
  //       (obj) => obj.app_id === appName
  //     )
  //     if (indextoRemove !== -1) {
  //       applications.splice(indextoRemove, 1)
  //     }

  //   }
  //   // eslint-disable-next-line no-unused-vars
  //   for (const [key, value] of Object.entries(applications)) {
  //     allApps.push(value.app_id);
  //   }
  //   console.log(allApps, "these are all the apps");
  //   if (allApps.includes("JA") && allApps.includes("CO")) {
  //     console.log("contains JA and CO");
  //   } else if (allApps.includes("JA")) {
  //     console.log("only contains JA");
  //     // delete JA in this case
  //     removeApps("JA")
  //     // removeApps("GD")
  //     console.log(applications, "Applications after removing JA");
  //   } else if (allApps.includes("CO")) {
  //     removeApps("CO")
  //     removeApps("GD")
  //   }

  //   if (!allApps.includes("GD")) {
  //     console.log("Grade Bldr is subscribed")
  //     removeApps("JA")
  //     removeApps("APP000007")
  //   }

  // });

  const [moduleType, setModuleType] = useState("");
  const handleModuleChange = (value, option) => {
    console.log(value, option?.children, "option?.children");
    console.log(applications, "SUBSCRIPTION IN ADDSUB");
    let app = option?.children;

    switch (app) {
      case "Trak Learning":
      case "Trak Coaching":
        setModuleType("enroll");
        formRef.current.setFieldsValue({
          subscription_type: null,
        });
        formRef.current.setFieldsValue({
          enrollment_type: null,
        });
        break;
      case "TraineryLMS":
        setModuleType("lms");
        formRef.current.setFieldsValue({
          subscription_type: "By Views",
        });
        break;
      case "CompBldr":
        setModuleType("cbldr");
        formRef.current.setFieldsValue({
          subscription_type: null,
        });
        // addRow();
        break;
      case "JobBldr":
      case "JA/MP":
        setModuleType("cpr");
        formRef.current.setFieldsValue({
          subscription_type: null,
        });
        break;
      case "Comp Project":
        setModuleType("cprCmp");
        setDisableOnComp(true);
        formRef.current.setFieldsValue({
          enrollment_type: "Consultant Company",
        });
        formRef.current.setFieldsValue({
          subscription_type: null,
        });
        break;
      case "GRADEBldr":
        setModuleType("cbldr");
        formRef.current.setFieldsValue({
          subscription_type: null,
        });
        break;
      case "Review Cloud":
        setModuleType("RC");
        formRef.current.setFieldsValue({
          subscription_type: null,
        });
        break;
      default:
        setModuleType("");
        setDisableOnComp(true);
        formRef.current.setFieldsValue({
          subscription_type: null,
        });
        break;
    }
  };
  const handleReset = () => {
    handleCancel();
    formRef.current.resetFields();
    setModuleType("");
    setAllocated_views_switch(true);
  };
  const [form] = Form.useForm();
  console.log(
    namingData.contract_end_date,
    dayjs(namingData.contract_end_date, "YYYY-MM-DD"),
    "namingData"
  );
  const handleFormChange = async (changedValues, allValues) => {
    if ("contract_id" in changedValues && allValues.contract_id.length > 2) {
      const response = await Axios.get(
        `/contractidcheck/${id}/?search=${allValues.contract_id}`
      );
      console.log(response);
      setIsUserExists(response.data.exists);
    }
  };

  const checkUserExists = () => {
    return new Promise(async (resolve, reject) => {
      if (isUserExists === undefined) {
        // API call has not completed yet, wait for it to complete and try again
        setTimeout(() => {
          checkUserExists().then(resolve, reject);
        }, 100);
      } else if (isUserExists) {
        reject("Contract ID already exists");
      } else {
        resolve();
      }
    });
  };
  return (
    <Modal
      title={<p className="modal-heading">SUBSCRIBE MODULE</p>}
      centered
      // open={modalOpen}
      // onOk={() => setModalOpen(false)}
      // onCancel={() => setModalOpen(false)}
      width={940}
      open={visible}
      onCancel={() => {
        handleReset();
      }}
      footer={[]}
    >
      <div style={{ marginBottom: "0.5rem" }}>
        <div style={{ marginTop: "1rem" }}>
          <Form
            name="complex-form"
            form={form}
            onFinish={onFinish}
            onValuesChange={handleFormChange}
            layout="vertical"
            ref={formRef}
            initialValues={{
              dateRange: [
                namingData.contract_start_date
                  ? dayjs(namingData.contract_start_date, "YYYY-MM-DD")
                  : null,
                namingData.contract_end_date
                  ? dayjs(namingData.contract_end_date, "YYYY-MM-DD")
                  : null,
              ],
            }}
            labelCol={{
              span: 25,
            }}
            wrapperCol={{
              span: 80,
            }}
            style={{
              Width: "100%",
            }}
            requiredMark={false}
          >
            <div className="group1" style={{ padding: "0rem" }}>
              <div className="antd-test-modal" style={{ marginTop: "2rem" }}>
                <Row gutter={20} style={{ marginLeft: "2rem" }}>
                  <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                    <Form.Item label={<p className="my-form-lables">Module</p>}>
                      <Form.Item
                        name="application"
                        rules={[
                          {
                            required: true,
                            message: "Application is required",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select Module"
                          name="application"
                          className="my-form-input-antd-test"
                          onChange={(value, option) => {
                            handleModuleChange(value, option);
                          }}
                        >
                          {applications?.map((app) => (
                            // app.app_id === 'CO' ? (
                            // <Option key={app.id} value={app.id}>
                            //   {app.name}
                            // </Option>
                            // ) : app.app_id === 'JA' ? (
                            // <Option key={app.id} value={app.id}>
                            //   {app.name}
                            // </Option>
                            // ) : (
                            <Option key={app.id} value={app.id}>
                              {app.name}
                            </Option>
                            // )
                          ))}
                        </Select>
                      </Form.Item>
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={12} md={5} lg={5} xl={5}>
                    <Form.Item
                      label={<p className="my-form-lables">Contract ID</p>}
                    >
                      <Form.Item
                        name="contract_id"
                        rules={[
                          {
                            min: 3,
                            message: "Minimum 3 characters required",
                          },
                          {
                            validator: checkUserExists,
                            validateTrigger: "onChange",
                          },
                        ]}
                      >
                        <Input
                          placeholder="Contract id"
                          name="contract_id"
                          className="my-form-input-antd-test"
                        />
                      </Form.Item>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={5} lg={5} xl={5}>
                    <Form.Item
                      label={<p className="my-form-lables">Billing Cycle</p>}
                    >
                      <Form.Item name="billing_cycle">
                        <Select
                          placeholder="Billing"
                          name="billing_cycle"
                          className="my-form-input-antd-test"
                          // onChange={handleBillingCycleChange}
                        >
                          {billings?.billing_cycle?.map((app) => (
                            <Option key={app} value={app}>
                              {app}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={10} lg={8} xl={8}>
                    <Form.Item
                      label={
                        <p className="my-form-lables">Start and End Date</p>
                      }
                    >
                      <Form.Item
                        name="dateRange"
                        rules={[
                          {
                            required: true,
                            message: "date is required",
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              const endDate = getFieldValue("dateRange")?.[1];
                              console.log(endDate, value);
                              if (!endDate) {
                                return Promise.reject("End date is required");
                              }
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <RangePicker
                          placeholder={["Start Date", "End Date"]}
                          name="dateRange"
                          className="my-form-input-antd-test"
                        />
                      </Form.Item>
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              {moduleType !== "cbldr" &&
                moduleType !== "cpr" &&
                moduleType !== "cprCmp" && (
                  <>
                    <div className="antd-test-modal">
                      <Row
                        gutter={moduleType === "lms" ? 15 : 20}
                        style={{ marginLeft: "2rem" }}
                      >
                        <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                          <Form.Item
                            label={
                              <p className="my-form-lables">
                                Subscription Type
                              </p>
                            }
                          >
                            <Form.Item name="subscription_type">
                              <Select
                                placeholder="Subscription Type"
                                name="subscription_type"
                                className="my-form-input-antd-test"
                              >
                                {moduleType !== "lms"
                                  ? subscription?.subscription_type?.map(
                                      (app) => (
                                        <Option key={app} value={app}>
                                          {app}
                                        </Option>
                                      )
                                    )
                                  : categoryType?.contract_type?.map((app) => (
                                      <Option key={app} value={app}>
                                        {app}
                                      </Option>
                                    ))}
                              </Select>
                            </Form.Item>
                          </Form.Item>
                        </Col>

                        <Col
                          xs={24}
                          sm={12}
                          md={10}
                          lg={moduleType === "lms" ? 4 : 5}
                          xl={moduleType === "lms" ? 4 : 5}
                        >
                          <Form.Item
                            label={<p className="my-form-lables">Category</p>}
                          >
                            <Form.Item name="subscription_category">
                              <Select
                                placeholder="Category"
                                name="subscription_category"
                                className="my-form-input-antd-test"
                              >
                                {category?.subscription_category?.map((app) => (
                                  <Option key={app} value={app}>
                                    {app}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Form.Item>
                        </Col>
                        {moduleType === "RC" && (
                          <>
                            <Col>
                              <Form.Item
                                label={
                                  <p className="my-form-lables">AI Enabled</p>
                                }
                              >
                                <Form.Item
                                  name="ai_enabled"
                                  // valuePropName="checked"
                                >
                                  <Switch
                                    checkedChildren="Enabled"
                                    unCheckedChildren="Disabled"
                                    checked={AiEnabled}
                                    onChange={(checked) =>
                                      setAiEnabled(checked)
                                    }
                                    style={{
                                      backgroundColor: AiEnabled
                                        ? "#87d068"
                                        : "#1890ff",
                                    }}
                                  />
                                </Form.Item>
                              </Form.Item>
                            </Col>
                          </>
                        )}
                        {moduleType === "enroll" && (
                          <>
                            <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                              <Form.Item
                                label={
                                  <p className="my-form-lables">
                                    Enrollment type
                                  </p>
                                }
                              >
                                <Form.Item
                                  name="enrollment_type"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Enrollment is required",
                                    },
                                  ]}
                                >
                                  <Select
                                    placeholder="Enrollment Type"
                                    name="enrollment_type"
                                    className="my-form-input-antd-test"

                                    // disabled={checkEnrollment()}
                                  >
                                    {enrollments?.enrollment_type?.map(
                                      (app) => (
                                        <Option key={app} value={app}>
                                          {app}
                                        </Option>
                                      )
                                    )}
                                  </Select>
                                </Form.Item>
                              </Form.Item>
                            </Col>
                            {env !== "prod" ? (
                              <Col>
                                <Form.Item
                                  label={<p className="my-form-lables">ILT</p>}
                                >
                                  <Form.Item name="allocated_view_flag">
                                    <Switch
                                      checkedChildren="Enabled"
                                      unCheckedChildren="Disabled"
                                      checked={ilt}
                                      onChange={(checked) => setIlt(checked)}
                                      style={{
                                        backgroundColor: ilt
                                          ? "#87d068"
                                          : "#1890ff",
                                      }}
                                    />
                                  </Form.Item>
                                </Form.Item>
                              </Col>
                            ) : (
                              ""
                            )}
                          </>
                        )}
                        {moduleType === "lms" && (
                          <>
                            <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                              <Form.Item
                                label={
                                  <p className="my-form-lables">
                                    Allocated Courses
                                  </p>
                                }
                              >
                                <Form.Item name="allocated_course_count">
                                  <InputNumber
                                    placeholder="Enter no."
                                    name="allocated_course_count"
                                    className="my-form-input-antd-test"
                                    // Add other InputNumber props as needed
                                  />
                                </Form.Item>
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={10} lg={4} xl={4}>
                              <Form.Item
                                label={
                                  <p className="my-form-lables">
                                    Purchased Views
                                  </p>
                                }
                              >
                                <Form.Item
                                  name="purchased_view_count"
                                  rules={[
                                    ({ getFieldValue }) => ({
                                      required:
                                        getFieldValue("subscription_type") ===
                                        "By Views",
                                      message: "Views are required",
                                    }),
                                  ]}
                                >
                                  <InputNumber
                                    placeholder="Enter no."
                                    name="purchased_view_count"
                                    className="my-form-input-antd-test"
                                    // Add other InputNumber props as needed
                                  />
                                </Form.Item>
                              </Form.Item>
                            </Col>
                            <Col
                              xs={24}
                              sm={12}
                              md={10}
                              lg={4}
                              xl={4}
                              style={{ display: "flex" }}
                            >
                              <Form.Item
                                label={
                                  <p className="my-form-lables">
                                    Allocated Views
                                  </p>
                                }
                              >
                                <Form.Item name="allocated_view_flag">
                                  <Switch
                                    checkedChildren="Unlimited"
                                    unCheckedChildren="Fixed"
                                    checked={allocated_views_switch}
                                    onChange={(checked) =>
                                      setAllocated_views_switch(checked)
                                    }
                                    style={{
                                      backgroundColor: allocated_views_switch
                                        ? "#87d068"
                                        : "#1890ff",
                                    }}
                                  />
                                </Form.Item>
                              </Form.Item>
                              {!allocated_views_switch && false && (
                                <div>
                                  <Form.Item
                                    label={<p className="my-form-lables"></p>}
                                  >
                                    <Form.Item
                                      name="allocated_view_count"
                                      rules={[
                                        {
                                          required: true,
                                          message: "required",
                                        },
                                      ]}
                                    >
                                      <InputNumber
                                        placeholder="Views"
                                        name="allocated_view_count"
                                        className="my-form-input"
                                        style={{ width: "7rem" }}
                                        // Add other InputNumber props as needed
                                      />
                                    </Form.Item>
                                  </Form.Item>
                                </div>
                              )}
                            </Col>
                            <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                              <Form.Item
                                label={<p className="my-form-lables">Amount</p>}
                              >
                                <Form.Item name="amount" noStyle>
                                  <InputNumber
                                    placeholder="Enter amount"
                                    name="amount"
                                    className="my-form-input-antd-test"
                                    addonAfter="$"
                                    formatter={(value) =>
                                      `${value}`.replace(
                                        /\B(?=(\d{3})+(?!\d))/g,
                                        ","
                                      )
                                    }
                                    parser={(value) =>
                                      value.replace(/\$\s?|(,*)/g, "")
                                    }
                                  />
                                </Form.Item>
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                              <Form.Item
                                label={
                                  <p className="my-form-lables">
                                    Purchase Status
                                  </p>
                                }
                                name="purchase_status"
                                rules={[
                                  {
                                    required: true,
                                    message: "Purchase status is required",
                                  },
                                ]}
                              >
                                <Select
                                  placeholder="Select Status"
                                  className="my-form-input-antd-test"
                                >
                                  <Option value="Pending">
                                    <span>
                                      <LoadingOutlined
                                        style={{
                                          color: "#faad14",
                                          marginRight: "8px",
                                        }}
                                      />
                                      Pending
                                    </span>
                                  </Option>
                                  <Option value="Failed">
                                    <span>
                                      <CloseOutlined
                                        style={{
                                          color: "#ff4d4f",
                                          marginRight: "8px",
                                        }}
                                      />
                                      Failed
                                    </span>
                                  </Option>
                                  <Option value="In Progress">
                                    <span>
                                      <SyncOutlined
                                        spin
                                        style={{
                                          color: "#1890ff",
                                          marginRight: "8px",
                                        }}
                                      />
                                      In Progress
                                    </span>
                                  </Option>
                                  <Option value="Success">
                                    <span>
                                      <CheckOutlined
                                        style={{
                                          color: "#52c41a",
                                          marginRight: "8px",
                                        }}
                                      />
                                      Success
                                    </span>
                                  </Option>
                                </Select>
                              </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={10} lg={9} xl={9}>
                              <Form.Item
                                label={
                                  <p className="my-form-lables">Description</p>
                                }
                                name="description"
                                rules={[
                                  {
                                    required: true,
                                    message: "Description is required",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Enter description"
                                  name="description"
                                  className="my-form-input-antd-test"
                                />
                              </Form.Item>
                            </Col>
                            {env !== "prod" ? (
                              <Col
                                xs={24}
                                sm={12}
                                md={10}
                                lg={4}
                                xl={4}
                                style={{ display: "flex" }}
                              >
                                <Form.Item
                                  label={<p className="my-form-lables">ILT</p>}
                                >
                                  <Form.Item name="allocated_view_flag">
                                    <Switch
                                      checkedChildren="Enabled"
                                      unCheckedChildren="Disabled"
                                      checked={ilt}
                                      onChange={(checked) => setIlt(checked)}
                                      style={{
                                        backgroundColor: ilt
                                          ? "#87d068"
                                          : "#1890ff",
                                      }}
                                    />
                                  </Form.Item>
                                </Form.Item>
                              </Col>
                            ) : (
                              ""
                            )}
                          </>
                        )}
                      </Row>
                    </div>
                  </>
                )}
              {moduleType === "cprCmp" && (
                <>
                  <div className="antd-test-modal">
                    <Row gutter={20} style={{ marginLeft: "2rem" }}>
                      <Col xs={24} sm={12} md={10} lg={8} xl={8}>
                        <Form.Item
                          label={
                            <p className="my-form-lables">Enrollment type</p>
                          }
                        >
                          <Form.Item name="enrollment_type">
                            {disableOnComp ? (
                              <Select
                                placeholder="Enrollment Type"
                                name="enrollment_type"
                                className="my-form-input-antd-test"
                                // disabled={checkEnrollment()}
                              >
                                {" "}
                              </Select>
                            ) : (
                              <Select
                                placeholder="Enrollment Type"
                                name="enrollment_type"
                                className="my-form-input-antd-test"
                                // disabled={checkEnrollment()}
                              >
                                {enrollments?.enrollment_type?.map((app) => (
                                  <Option key={app} value={app}>
                                    {app}
                                  </Option>
                                ))}
                              </Select>
                            )}
                          </Form.Item>
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                </>
              )}
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                height: "2rem",
                marginTop: "0.1rem",
                marginBottom: "1rem",
              }}
            >
              <Form.Item style={{ marginRight: "1rem" }}>
                <Button key="back" onClick={() => handleReset()}>
                  <CloseOutlined />
                  Cancel
                </Button>
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    background: "#f58029",
                    fontWeight: "600",
                  }}
                  className="save-update-btn"
                  disabled={loading}
                >
                  SAVE
                  {loading ? <LoadingOutlined /> : <FormOutlined />}
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>
      </div>
    </Modal>
  );
};

export default AddSub;
